import React, { useMemo } from "react";

import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import { useTranslation } from "react-i18next";

import { useVideoSurveyInventory } from "../../../../hooks/useVideoSurveyInventory";
import { RoomJob } from "../../../../models/sales";
import useVideoContext from "../../hooks/useVideoContext/useVideoContext";
import useStyles, { OnlineDot, OfflineDot, NotOutlinedSelect } from "./styles";
import { SelectChangeEvent } from "@mui/material";

const MainHeader = () => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  const { task, participantsAllowed } = useVideoContext();

  const { inventory, selectedRoomName, setSelectedRoomName } = useVideoSurveyInventory();

  const rooms = useMemo(() => inventory?.map((room: RoomJob) => room.name), [inventory]);

  const ConsultantInfo = (
    <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-start">
      <span data-cy="jobReference" className={classes.taskNumber}>{`#${
        task?.job.reference ? task.job.reference : ""
      }`}</span>
      <span data-cy="jobCustomerName" className={classes.customerName}>{`${
        task?.job.customer?.name ? task.job.customer.name : ""
      }`}</span>
      {participantsAllowed?.length > 0 ? (
        <>
          <OnlineDot />
          <span data-cy="labelStatus">{translate("online")}</span>
        </>
      ) : (
        <>
          <OfflineDot />
          <span data-cy="labelStatus">{translate("offline")}</span>
        </>
      )}
    </Stack>
  );

  const SelectRoom = (
    <Stack direction="row" alignItems="center" justifyContent="flex-end">
      <span className={classes.taskNumber}>{translate("room")}</span>
      <NotOutlinedSelect
        dataCy="roomSelectName"
        name="room"
        value={selectedRoomName ?? ""}
        onChange={(event: SelectChangeEvent<any>) => setSelectedRoomName(event.target.value)}
      >
        <MenuItem key="empty" value="">
          {translate("empty")}
        </MenuItem>
        {rooms?.map((roomName: string, index: number) => (
          <MenuItem data-cy={roomName} key={index} value={roomName}>
            {roomName}
          </MenuItem>
        ))}
      </NotOutlinedSelect>
    </Stack>
  );

  return (
    <>
      {ConsultantInfo}
      {SelectRoom}
    </>
  );
};

export default MainHeader;
